const filterBy = ['', 'metropolitan_area', 'city', 'median_zone'];

export default filterBy;
